import { getGenericStore } from './genericStore';

const constructionDataStore = Object.create(getGenericStore());
export default constructionDataStore;